/**
 * Map API - Geographic boundary data for district visualization
 */

import { apiFetch } from './client';

export interface DistrictPolygonProperties {
  educationOrganizationId: number;
  leaId: number;
  name: string;
  shortName: string | null;
  leaType: string | null;
  enrollment: number | null;
  superintendentName: string | null;
}

export interface DistrictPolygonFeature {
  type: 'Feature';
  geometry: GeoJSON.Polygon | GeoJSON.MultiPolygon;
  properties: DistrictPolygonProperties;
}

export interface DistrictPolygonsResponse {
  type: 'FeatureCollection';
  features: DistrictPolygonFeature[];
}

export interface SchoolPointProperties {
  schoolId: number;
  name: string;
  districtName: string | null;
  leaId: number | null;
  enrollment: number | null;
  schoolType: string | null;
}

export interface SchoolPointFeature {
  type: 'Feature';
  geometry: { type: 'Point'; coordinates: [number, number] };
  properties: SchoolPointProperties;
}

export interface SchoolPointsResponse {
  type: 'FeatureCollection';
  features: SchoolPointFeature[];
}

export interface AddressLookupLogPayload {
  matched: boolean;
  leaId?: number | null;
  districtName?: string | null;
  outOfArea?: boolean;
  provider?: string;
}

export const mapApi = {
  /**
   * Get all district boundary polygons as GeoJSON FeatureCollection
   */
  getPolygons: (): Promise<DistrictPolygonsResponse> =>
    apiFetch<DistrictPolygonsResponse>('/map/polygons'),

  /**
   * Get all school locations as GeoJSON FeatureCollection of Points
   */
  getSchools: (): Promise<SchoolPointsResponse> =>
    apiFetch<SchoolPointsResponse>('/map/schools'),

  /**
   * Record that an address-to-district lookup occurred (no raw address is sent).
   * Fire-and-forget; failures are non-fatal to the lookup.
   */
  logLookup: (payload: AddressLookupLogPayload): Promise<void> =>
    apiFetch<void>('/map/lookups', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
